<script setup lang="ts">
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://v3.vuejs.org/api/sfc-script-setup.html#sfc-script-setup
import { ConfigProvider } from 'ant-design-vue';
// import Watermark from '@/components/Watermark';
// import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
// import zhCN from 'ant-design-vue/es/locale/zh_CN';
// // import 'dayjs/locale/zh-cn';
// import dayjs from 'dayjs';
// import dayjs from 'ant-design-vue/node_modules/dayjs';

// import SystemHead from '@/components/SystemHead';
// import MultiTab from '@/components/MultiTab';

import zhCN from 'ant-design-vue/es/locale/zh_CN';
// import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { transformCellText } from './store/system/user';
import { encryptionField } from './store/system/user/const';
import { TransformCellTextProps } from 'ant-design-vue/lib/table/interface';
// 引入ant-design-vue的dayjs中文包，解决直接引入dayjs配置语言失效的bug
// import dayjs from 'ant-design-vue/node_modules/dayjs';
// import 'ant-design-vue/node_modules/dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
// ConfigProvider.config({
//   // theme: {
//   //   infoColor: '#000',
//   // },
// });
const fun = transformCellText as unknown as (
  tableProps: TransformCellTextProps
) => any;
</script>

<template>
  <ConfigProvider :locale="zhCN" :transform-cell-text="fun">
    <!-- <router-view :key="Math.random()"></router-view> -->
    <router-view></router-view>
  </ConfigProvider>
</template>

<style lang="less">
@import url('ant-design-vue/dist/antd.variable.less');
// @import url('ant-design-vue/dist/antd.less');
@import url('@/assets/styles/common/var.css');
@import url('@/assets/styles/common/common.less');
@import url('@/assets/styles/common/var.less');
// @import url('@/assets/styles/common/antdesign.less');
// @import url('@/assets/styles/common/theme/dark.css');
@import url('@/assets/styles/common/theme/light.less');
@import url('@fortawesome/fontawesome-svg-core/styles.css');
</style>
